module.exports = __webpack_public_path__ + "static/media/webdesign-services-img17.5a237146.jpg";